// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hook_wrapper__1aylG","container":"Hook_container__6GDrK","text":"Hook_text__53_Cp","actions":"Hook_actions__3hXsL","button":"Hook_button__2jSaw"};